<template>
  <div>
    <div class="row sticky-button">
      <div class="col-12 col-sm-7 col-md-5 col-lg-5 px-0">
        <div class="form-group has-label">
          <minus-plus
            :label="`${$t('common_words.contacts')}: *`"
            @handlePlus="handlePlus"
            @handleMinus="handleMinus"
            :value="model.contact_number"
          />
        </div>
      </div>
    </div>
    <div
      class="row py-3 mb-4 shadow-sm"
      style="border: 0.5px solid #6ba6524d"
      :key="index"
      v-for="index in model.contact_number"
    >
      <div class="col-12 col-md-12 col-lg-5 col-xl-5">
        <fg-input
          :label="`${$t('common_words.email')} ${index}: *`"
          class="shadow-sm pl-0 required-email"
          ref="email"
          type="email"
          v-model="model.email[index - 1]"
          placeholder="example@gmail.com"
        ></fg-input>
      </div>
      <div class="col-12 col-md-6 col-lg-3 col-xl-3">
        <div class="form-group has-label">
          <label>{{ `${$t('inventory.email_type')} ${index}: ` }} </label>
          <br />
          <el-select
            clearable
            collapse-tags
            filterable
            multiple
            :class="`select-primary custom-width-select shadow-sm required-type${
              index - 1
            }`"
            size="large"
            v-model="model.type[index - 1]"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="(option, index) in emailTypes"
              class="select-primary"
              :value="option.value"
              :label="option.label"
              :key="index + option.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 col-xl-4">
        <fg-input
          :label="`${$t('common_words.phone')} ${index}: `"
          class="pl-0 required-phone"
          ref="phone"
          type="number"
          v-model="model.phone[index - 1]"
          placeholder="300-xxxx-xxxx"
        ></fg-input>
      </div>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util';
import i18n from 'src/i18n';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      emailTypes: [],
      model: {
        contacts_id: [],
        contact_number: 1,
        email: [],
        phone: [],
        type: [],
      },
    };
  },
  computed: {
    getEmailTypes() {
      return [
        {
          id: '1',
          value: 'Pago',
          label: i18n.t('inventory.payment'),
        },
        {
          id: '2',
          value: 'Orden de Pago',
          label: i18n.t('inventory.payment_order'),
        },
      ];
    },
  },
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
  ],
  methods: {
    handlePlus() {
      this.model.contact_number++;
    },
    handleMinus() {
      const minNumber = 1;
      if (this.model.contact_number > minNumber) {
        this.handleNumberChange();
        this.model.contact_number--;
      }
    },
    handleNumberChange() {
      this.model.email = this.model.email.splice(0, this.model.contact_number);
      this.model.phone = this.model.phone.splice(0, this.model.contact_number);
      this.model.type = this.model.type.splice(0, this.model.contact_number);
    },
    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      return emailRegex.test(email);
    },
    formarterValue() {
      for (let i = 0; i < this.model.contact_number; i++) {
        if (!isset(this.model.email[i])) {
          this.$set(this.model.email, i, null);
        }
        if (!isset(this.model.type[i])) {
          this.$set(this.model.type, i, []);
        }
        if (!isset(this.model.phone[i])) {
          this.$set(this.model.phone, i, null);
        }
      }
    },
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.model.email.length == 0)
            return this.validationInputsRequired('email');
          else if (!isset(this.model.type[0]))
            return this.validationInputsRequired(`type${0}`);
          else if (this.model.phone.length == 0)
            return this.validationInputsRequired('phone');

          for (let i = 0; i < this.model.contact_number; i++) {
            if (
              !this.validateEmail(this.model.email[i]) &&
              isset(this.model.email[i])
            ) {
              SweetAlert.warning(i18n.t('inventory.invalidEmail'));

              return false;
            }
            if (isset(this.model.email[i]) && !isset(this.model.type[i])) {
              return this.validationInputsRequired(`type${i}`);
            }
            if (isset(this.model.type[i]) && !isset(this.model.email[i])) {
              return this.validationInputsRequired('email');
            }
            if (
              !isset(this.model.email[i]) &&
              !isset(this.model.email[i]) &&
              !isset(this.model.phone[i])
            ) {
              this.handleMinus();
            }
          }
          this.formarterValue();
          this.$emit('on-validated', this.model);
          
          return isValid;
        }
      });
    },
  },
  mounted() {
    let editForm = {};
    this.emailTypes = this.getEmailTypes;
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      this.model.email = [];
      this.model.phone = [];
      this.model.type = [];
      this.model.contacts_id = [];
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.contact_number = editForm.provider_contacts.length;
      editForm.provider_contacts.forEach((element) => {
        this.model.contacts_id.push(element.id);
        this.model.email.push(element.email);
        this.model.phone.push(element.phone);
        const types = element.provider_type_email.map((type) => type.type);
        this.model.type.push(types);
      });
    }
  },
};
</script>
